export var AT=function(AT){AT["UPDATE_INSTALLATION_SLOT_DATA_BY_BASKET_ID"]="UPDATE_INSTALLATION_SLOT_DATA_BY_BASKET_ID";return AT;}({});